import { Component, OnInit } from "@angular/core";
import { scrollToTop } from "src/app/helpers/helpers";
import { MetaService } from "src/app/services/meta.service";

interface BlogPost {
  /** ISO date (yyyy-mm-dd) used for sorting newest-first */
  date: string;
  /** Human readable date shown in the card */
  displayDate: string;
  title: string;
  image: string;
  paragraphs: string[];
  link?: { url: string; label: string };
}

@Component({
  selector: "app-bizden-haberler",
  templateUrl: "./bizden-haberler.component.html",
  styleUrls: ["./bizden-haberler.component.scss"],
})
export class BizdenHaberlerComponent implements OnInit {
  fallbackImage = "assets/images/bilgesin.png";

  posts: BlogPost[] = [
    {
      date: "2026-05-25",
      displayDate: "25 Mayıs 2026",
      title: "Bilgesin, Kariyer Fest'26'da Genç Yeteneklerle Buluştu!",
      image: "assets/images/bizden-haberler/kariyer-fest-26.jpg",
      paragraphs: [
        "Bilgesin ekibi olarak, 6 Mayıs'ta Fatih Sultan Mehmet Vakıf Üniversitesi Topkapı Yerleşkesi'nde düzenlenen Kariyer Fest'26 etkinliğine katıldık. Gün boyunca süren atölye çalışmaları, VR deneyimleri ve Coffee Village etkinlikleriyle dolu bu festivalde, geleceğin profesyonelleriyle bir araya gelmek bizim için heyecan vericiydi.",
        "Standımızda öğrencilerle buluşarak Bilgesin'in \"tüketici fikirlerini içgörüye dönüştüren\" ekosistemini anlattık. Kullanıcılarımızın fikirlerini paylaşarak markaları beslediği, karşılığında ise sevdikleri markalardan özel indirimler kazandığı modelimiz, katılımcıların yoğun ilgisiyle karşılaştı.",
        "Gençlerin dinamizmi ve teknoloji odaklı bakış açıları, Bilgesin olarak sunduğumuz dijital çözüm yolculuğunda bizlere ilham verdi. Bu güzel organizasyonda emeği geçen tüm ekiplere ve enerjileriyle günümüzü güzelleştiren tüm öğrencilere teşekkür ederiz!",
      ],
    },
    {
      date: "2024-12-24",
      displayDate: "24 Aralık 2024",
      title: "Bilgesin, BTM Sahne XL Etkinliğinde İnovatif Modelini Tanıttı!",
      image: "assets/images/bizden-haberler/btm-sahne-xl.jpg",
      paragraphs: [
        "Bilgesin ekibi olarak, girişimcilik dünyasının kalbinin attığı, Bilgiyi Ticarileştirme Merkezi (BTM) tarafından düzenlenen Sahne XL etkinliğinde yer almanın gururunu yaşadık. İnovatif fikirlerin ve yatırımcıların buluşma noktası olan bu büyük organizasyonda, Bilgesin'in büyüme yolculuğunu ve vizyonunu ekosistemle paylaştık.",
        "Etkinlik boyunca yatırımcılar, mentorlar ve girişim meraklılarıyla bir araya gelerek; tüketicilerin fikirlerini topluluk gücüyle markalar için değerli içgörülere dönüştüren ve karşılığında tüketicilere kazanç sağlayan iş modelimizi aktardık. Sahne XL'ın dinamik atmosferi, Bilgesin'in sektördeki yerini sağlamlaştırma ve yeni iş birliklerine kapı aralama noktasında bizlere harika bir zemin sundu.",
        "Girişimimizi destekleyen BTM ailesine, standımızı ziyaret eden ve heyecanımıza ortak olan tüm katılımcılara teşekkür ederiz. Bilgesin olarak, tüketicinin sesini markalarla buluşturarak ekosisteme değer katmaya devam edeceğiz!",
      ],
    },
    {
      date: "2022-08-10",
      displayDate: "10 Ağustos 2022",
      title: "Bilgesin, BTM Ekosisteminde Büyümeye Devam Ediyor!",
      image: "assets/images/bizden-haberler/btm-ekosistem.jpg",
      paragraphs: [
        "Bilgesin olarak, Ağustos 2022'den bu yana BTM Kuluçka Programı kapsamında girişimcilik yolculuğumuzu sürdürmekten büyük mutluluk duyuyoruz.",
        "İstanbul Ticaret Odası tarafından, yenilikçi iş fikirlerinin ticarileşmesini desteklemek amacıyla kurulan BTM'nin sunduğu güçlü ekosistem; girişimimizi geliştirme, iş modelimizi güçlendirme ve yeni iş birlikleri kurma süreçlerinde bize önemli katkılar sağladı.",
        "\"Tüketici fikirlerini içgörüye dönüştüren\" yapımızla markalar ve kullanıcılar arasında değer odaklı bir köprü kurarken, BTM'nin girişimcilik ekosistemindeki desteğiyle büyümeye devam ediyoruz.",
        "Bu süreçte yanımızda olan BTM ekibine teşekkür eder, birlikte daha nice başarı hikâyeleri üretmeyi dileriz!",
      ],
      link: {
        url: "https://btm.istanbul/girisimler/bilgesin",
        label: "https://btm.istanbul/girisimler/bilgesin",
      },
    },
  ];

  constructor(private metaService: MetaService) {}

  ngOnInit(): void {
    scrollToTop();

    // Show newest news first
    this.posts = [...this.posts].sort((a, b) => b.date.localeCompare(a.date));

    this.metaService.set({
      title: "Bizden Haberler - Bilgesin'in etkinlik ve gelişmeleri - Bilgesin",
      description:
        "Bilgesin'in katıldığı etkinlikler, iş birlikleri ve girişimcilik yolculuğundan en güncel haberler.",
    });
  }

  onImageError(event: Event): void {
    (event.target as HTMLImageElement).src = this.fallbackImage;
  }
}
